<template>
<div class="ex-wrapper">
		<div class="heading">Button Group</div>
		<div class="description">All Information about Button Group.</div>

		<div class="example-set">
			<div class="example">
				<div class="button-group">
					<div class="first -active">Option 1</div>
					<div class="mid">Option 2</div>
					<div class="last">Option 3</div>
				</div>
			</div>
			<pre class="use">
				<code class="language-markup" style="tab-size:1;">
					<span class="token tag"><span class="token tag"><span class="token punctuation">&lt;</span>div</span> <span class="token attr-name">class</span><span class="token attr-value"><span class="token punctuation">=</span><span class="token punctuation">"</span>button-group<span class="token punctuation">"</span></span><span class="token punctuation">></span></span>
					  <span class="token tag"><span class="token tag"><span class="token punctuation">&lt;</span>div</span> <span class="token attr-name">class</span><span class="token attr-value"><span class="token punctuation">=</span><span class="token punctuation">"</span>first -active<span class="token punctuation">"</span></span><span class="token punctuation">></span></span>Option 1<span class="token tag"><span class="token tag"><span class="token punctuation">&lt;/</span>div</span><span class="token punctuation">></span></span>
					  <span class="token tag"><span class="token tag"><span class="token punctuation">&lt;</span>div</span> <span class="token attr-name">class</span><span class="token attr-value"><span class="token punctuation">=</span><span class="token punctuation">"</span>mid<span class="token punctuation">"</span></span><span class="token punctuation">></span></span>Option 2<span class="token tag"><span class="token tag"><span class="token punctuation">&lt;/</span>div</span><span class="token punctuation">></span></span>
					  <span class="token tag"><span class="token tag"><span class="token punctuation">&lt;</span>div</span> <span class="token attr-name">class</span><span class="token attr-value"><span class="token punctuation">=</span><span class="token punctuation">"</span>last<span class="token punctuation">"</span></span><span class="token punctuation">></span></span>Option 3<span class="token tag"><span class="token tag"><span class="token punctuation">&lt;/</span>div</span><span class="token punctuation">></span></span>
					<span class="token tag"><span class="token tag"><span class="token punctuation">&lt;/</span>div</span><span class="token punctuation">></span></span>
				</code>
			</pre>

		</div>
		
	</div>
</template>

<script>
var Prism = require('prismjs')
var code = `
`
var html = Prism.highlight(code, Prism.languages.markup)

export default {
  name: 'ex-buttongroup',
  data () {
    return {
      tag: html
    }
  },
  created () {
    // console.log(this.tag)
  }
}
</script>


// WEBPACK FOOTER //
// ex-buttongroup.vue?b43597c2